import { configureStore } from "@reduxjs/toolkit";
import unoUserSlice from "./slice/userSlice";
import unoApplicationSlice from "./slice/applicationSlice";
import unoConfigSlice from "./slice/configSlice";

export const unoStore = configureStore({
  reducer: {
    user: unoUserSlice,
    application: unoApplicationSlice,
    config: unoConfigSlice,
  },
});
